import React from 'react';
import * as Yup from "yup";

import PriceDetails from './components/priceDetails/PriceDetails';
import {getTodayMidnight} from 'data/utils/shortcuts';

import AbstractProductDetailsForm from 'gui/components/editors/commons/editor/components/abstractProductDetailsForm';
import VoucherDetails from './components/voucherDetails';
import {Grid} from '@material-ui/core';
import TransferableCheckbox from 'gui/components/transferableCheckBox';
import {IVoucherDetails} from 'data/interfaces/products';
import {eVoucherTypes} from 'data/enums/products';
import {pick} from "lodash";


interface IVoucherDetailsFormProps {
  onSubmit: (formValues) => Promise<any>;
  voucherDetails?: IVoucherDetails;
  isAdmin?: boolean;
  setSubmitRef?: any;
  commonFormComponents?: any;
  productFieldHide?: any;
}

export const voucherDetailsYupSchemaObject = Yup.object({
  type: Yup.number().min(1, "יש לבחור סוג שובר").max(99999).required("יש לבחור סוג שובר"),
  voucherBalance: Yup.number()
    .min(1, "הסכום שבשובר יש להיות גבוהה מ-1")
    .max(999999, "ערך השובר יש להיות נמוך מ-999999")
    .required("יש לציין את הערך הכספי שבשובר"),
  currency: Yup.number().min(1, "יש לבחור מטבע").max(10).required("יש לבחור מטבע"),
  companyDetails: Yup.object()
    //   .required("יש לבחור את החברה של השובר")
    .when('type', (type, company) => [eVoucherTypes.agencies, eVoucherTypes.cruise, eVoucherTypes.hotels].includes(type)
      ? company.shape({
          name: Yup.string().max(50).required("יש לרשום שם חברה"),
          domain: Yup.string().max(50),
          assets: Yup.array().min(0, "יש לבחור לפחות תמונה אחת").max(30).optional(),
        }
      ).required("יש לבחור חברה")
      : company
        .nullable()
        .optional()
    ),
  companyClassifications: Yup.array(),
  areasPick: Yup.array(),
  imagePick: Yup.array(),
  placeDetails: Yup.object()
    .when('type', (type, hotel) => [].includes(type)
      ? hotel.shape({
        id: Yup.number(),
        place_id: Yup.string().min(1).max(1000).required("יש לבחור כתובת")
      }).required("יש לבחור כתובת")
      : hotel.nullable()
        .optional()),
  flightCompanyDetails: Yup.object()
    .when('type', (type, airline) => type === eVoucherTypes.flightCompanies
      ? airline.shape({
        name: Yup.string().min(1).max(100).required("יש לבחור חברת תעופה הלוך"),
        iata: Yup.string().min(1).max(10).required("יש לבחור חברת תעופה הלוך"),
        icao: Yup.string().min(1).max(10).required("יש לבחור חברת תעופה הלוך"),
        country: Yup.string().min(1).max(100).required("יש לבחור חברת תעופה הלוך").optional().nullable(),
        id: Yup.mixed().optional().nullable(),
        alid: Yup.mixed().optional().nullable(),
        callsign: Yup.mixed().optional().nullable(),
      }).required("יש לבחור חברת תעופה")
      : airline.nullable()
        .optional()),
  description: Yup.string().max(10000),
  conditions: Yup.string().max(10000),
  expiration: Yup.number().min(getTodayMidnight().getTime()).required("יש לבחור תוקף").nullable(),
  logosPick: Yup.mixed().optional(),
  acceptedTerms: Yup.boolean()
    .required("Required")
    .oneOf([true], "יש לאשר את התנאים לפני השימוש"),
  acceptedTransferable: Yup.boolean()
    .required("Required")
    .oneOf([true], "יש לאשר שהשובר ניתן להעברה"),
  firstName: Yup.string().max(100).optional().nullable(),
  lastName: Yup.string().max(100).optional().nullable(),
  code: Yup.string().max(100).optional(),
  phone: Yup.string().max(22).optional().nullable(),
  websiteUrl: Yup.string().max(1000).optional(),
  files: Yup.mixed()
    .when('skipFilesCheck', (skipFilesCheck, filesYup) => skipFilesCheck === true
      ? filesYup.array(Yup.mixed()).min(1, "יש לבחור קובץ של השובר")
      : filesYup.nullable().optional()),
}).noUnknown(true);

export const voucherDetailsInitialValues = {
  voucherBalance: undefined,
  type: 0,
  currency: 2,
  expiration: null,
  companyDetails: {},
  companyClassifications: [],
  placeDetails: undefined,
  flightCompanyDetails: undefined,
  acceptedTerms: false,
  acceptedTransferable: false,
  logosPick: [],
  description: '',
  conditions: '',
  firstName: '',
  lastName: '',
  code: '',
  websiteUrl: '',
  phone: '',
  files: [],
  tags: undefined,
  areasPick: [],
  imagePick: [],
};

const VoucherDetailsForm = (props: IVoucherDetailsFormProps) => (<AbstractProductDetailsForm
  {...props}
  initialValues={{
    ...voucherDetailsInitialValues,
    ...props.voucherDetails
  }}
  yupSchemaObject={voucherDetailsYupSchemaObject}
  formComponents={({submitForm, submitCount, isSubmitting, setFieldValue, values, touched, errors}) => (
    <>
      <VoucherDetails values={values}
                      errors={errors}
                      touched={touched}
                      setFieldValue={setFieldValue}
                      productFieldHide={props.productFieldHide}
      />
      <Grid item xs={12} style={{marginTop: 30}}/>
      <PriceDetails values={values as any}/>
    </>
  )}
  additionalCheckboxComponents={({submitCount, setFieldValue, values, touched, errors}) => <TransferableCheckbox/>}

  onSubmit={(formValues) => props
    .onSubmit({
      voucherDetails: pick(formValues, Object.keys(voucherDetailsInitialValues))
    })}

/>);

VoucherDetailsForm.defaultProps = {
  onSubmit: (formValues) => new Promise((resolve) => {
    
    setTimeout(resolve, 1000);
  }),
  voucherDetails: {},
  setSubmitRef: () => {
  },
  commonFormComponents: () => null,
};

export default React.memo(VoucherDetailsForm);
